import { useTranslation } from 'react-i18next'

import { cn } from '#/shared/lib/utils'
import { MARKET_RATE_STATUSES } from '../model/types'
import type { MarketRateStatus } from '../model/types'

const STATUS_STYLES: Record<
  MarketRateStatus,
  { container: string; dot: string }
> = {
  [MARKET_RATE_STATUSES.DELIVERED]: {
    container: 'bg-green-50 text-green-600',
    dot: 'bg-green-600',
  },
  [MARKET_RATE_STATUSES.IN_TRANSIT]: {
    container: 'bg-orange-100 text-orange-400',
    dot: 'bg-orange-400',
  },
  [MARKET_RATE_STATUSES.PICKED_UP]: {
    container: 'bg-orange-100 text-orange-400',
    dot: 'bg-orange-400',
  },
  [MARKET_RATE_STATUSES.DISPATCHED]: {
    container: 'bg-blue-50 text-blue-500',
    dot: 'bg-blue-500',
  },
  [MARKET_RATE_STATUSES.CANCELED]: {
    container: 'bg-red-50 text-red-500',
    dot: 'bg-red-500',
  },
  [MARKET_RATE_STATUSES.LISTED]: {
    container: 'bg-gray-100 text-gray-500',
    dot: 'bg-gray-400',
  },
}

interface MarketRateStatusPillProps {
  status: MarketRateStatus
  fallbackLabel?: string
}

export function MarketRateStatusPill({
  status,
  fallbackLabel,
}: MarketRateStatusPillProps) {
  const { t } = useTranslation()
  const styles = STATUS_STYLES[status]
  const knownLabel = t(`table.marketRate.statuses.${status}`, {
    defaultValue: '',
  })
  const label = knownLabel.length ? knownLabel : (fallbackLabel ?? status)

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.25 rounded-full px-1.75 py-0.5 text-xs font-medium',
        styles.container,
      )}
    >
      <span className={cn('size-1.5 rounded-full', styles.dot)} aria-hidden />
      {label}
    </span>
  )
}
